<template>
  <div>
    <div v-if="promocodes.length">
      <div v-for="promocode in promocodes"
           :key="promocode.promocode">
        {{promocode.promocode}}
        <span
        v-if="promocode.promoable && promocode.promoable_type === 'order_base'"
        >
          (заказ от {{moment(promocode.promoable.datetime).format(DATE_VIEW)}})
        </span>
      </div>
    </div>
    <div v-else>
      Промокодов не найдено
    </div>
  </div>
</template>

<script>
import moment from 'moment';
/* constants */
import { DATE_VIEW } from '@/constants/dates';
/* proxies */
import PromocodeSimpleProxy from '@/proxies/Promocodes/PromocodeSimpleProxy';

export default {
  name: 'PromocodesSimpleList',
  props: {
    contactUuid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      moment,
      DATE_VIEW,
      promocodes: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    contactUuid() {
      this.fetchData();
    },
  },
  methods: {
    fetchData() {
      new PromocodeSimpleProxy()
        .setParameters({
          page: {
            number: 1,
            size: 99999999,
          },
          owner_uuid: this.contactUuid,
        })
        .all()
        .then((response) => {
          this.promocodes = response.data.data.promocodes.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>

</style>
